module.exports = __webpack_public_path__ + "img/icon-share.41954643.svg";